import { Ordering } from "../types/ordering";
import { IOrdering } from "../types/pagination";

export const getFieldOrdering = (fieldName: string, ordering: IOrdering): Ordering | null => {
  const isSameField = fieldName.toLowerCase() === ordering.orderBy.toLowerCase();

  if (!isSameField) {
    return null;
  }

  return ordering.descending ? Ordering.Desc : Ordering.Asc;
};
